// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

// スマホヘッダーメニューの開閉
jQuery(function($){
  const spToggle = '.js-sp-gm-toggle';
  const spGm = '.js-sp-gm';
  const gmLogo = '.js-sp-gm-logo';
  $(spToggle).on('click',function(){
    $('header').toggleClass('is-active');
    $(this).toggleClass('is-active');
    $(spGm).slideToggle(300);
    $(gmLogo).toggleClass('is-active');
  })
})

// スマホフロートメニューの開閉
jQuery(function($){
  const toggle = '.js-sp-float-toggle';
  $(toggle).find('a').on('click',function(){
    $(this).parents('ul').toggleClass('is-active');
  })
})

// ページトップ
jQuery(function ($) {
  let pagetop = $('.js-page-top');
  pagetop.on('click',function () {
    $('body, html').animate({
        scrollTop: 0
    }, 500);
    return false;
  });
});

// スムーススクロール
jQuery(function($){
  $('a[href^="#"]').click(function(){
    // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
    var adjust = -100;
    // スクロールの速度（ミリ秒）
    var speed = 400;
    // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
    var href= $(this).attr("href");
    // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
    var position = target.offset().top + adjust;
    // スムーススクロール linear（等速） or swing（変速）
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  })
})